import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import { copyToClipboard } from "../../utils/clipboard";

/*
    Small copy-to-clipboard button. reactstrap only — no new UI kit.

    `value` may be credential material, so it is neither logged nor stored
    anywhere but the clipboard.
*/
const CopyButton = ({
  value,
  label = "Copy",
  copiedLabel = "Copied",
  className = "",
  disabled = false,
  ariaLabel,
}) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    },
    []
  );

  const handleCopy = async () => {
    const ok = await copyToClipboard(value);
    setCopied(ok);
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      type="button"
      size="sm"
      color="site-lite-btn"
      className={`api-access__copy-btn ${className}`}
      onClick={handleCopy}
      disabled={disabled || !value}
      aria-label={ariaLabel || label}
    >
      {copied ? copiedLabel : label}
    </Button>
  );
};

export default CopyButton;
